<template>
  <div class="layout-message-center">
    <template v-if="messageInit">
      <div class="message-tabs-pane">
        <el-tabs v-model="messageType">
          <el-tab-pane v-for="option in tab.options" :key="option.type" :name="option.type">
          <span slot="label">
            <span v-if="option.type === 'UnreadMessage'">
              <el-badge :value="unreadCount" :max="99" :hidden="unreadCount <= 0">
                <span>{{option.label}}</span>
              </el-badge>
            </span>
            <span v-else>
              <span>{{option.label}}</span>
            </span>
          </span>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="message-tabs-router">
        <transition :name="'animation-pull-' + pullStyle">
          <keep-alive>
            <component :is="messageType"></component>
          </keep-alive>
        </transition>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import TotalMessage from './message/TotalMessage'
import ReadMessage from './message/ReadMessage'
import UnreadMessage from './message/UnreadMessage'
import MarkMessage from './message/MarkMessage'
import Navigator from '../mixins/navigator'
import messageEvent from '../constants/messageEvent'
export default {
  name: 'LayoutMessageCenter',
  mixins: [Navigator],
  components: {TotalMessage, ReadMessage, UnreadMessage, MarkMessage},
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  provide () {
    return {
      $messageCenter: this
    }
  },
  data () {
    return {
      messageInit: false,
      messageType: 'TotalMessage',
      tab: {
        options: [{
          type: 'TotalMessage',
          label: '全部',
          icon: 'iconfont icon-bulletin'
        }, {
          type: 'UnreadMessage',
          label: '未读',
          icon: 'iconfont icon-info'
        }, {
          type: 'ReadMessage',
          label: '已读',
          icon: 'iconfont icon-info-read'
        }, {
          type: 'MarkMessage',
          label: '标记',
          icon: 'iconfont icon-attended'
        }]
      },
      pullStyle: '',
      subscribe: {
        channels: [
          '/receiveUser/subscribeTopic/biz/group-msg/manager'
        ],
        handlers: []
      }
    }
  },
  computed: mapState({
    unreadCount: state => state.message.unreadCount,
    stompClient: state => state.stomp.client
  }),
  methods: {
    ...mapMutations([
      'updateMessageUnreadCount',
      'cleanMessageUnreadCount',
      'increaseMessageUnreadCount',
      'decreaseMessageUnreadCount'
    ]),
    hideLayout () {
      this.$emit('update:visible', false)
    },
    onReceiveMessage (message) {
      if (message && message.body) {
        const body = JSON.parse(message.body)
        if (body) {
          this.$notify({
            title: body.title,
            message: body.message,
            type: 'warning',
            offset: 64
          })
        }
      }
      this.$bus.$emit(messageEvent.subscribe.NEW_MESSAGE)
    },
    subscribeMessage () {
      if (this.stompClient) {
        this.subscribe.handlers = this.subscribe.channels
          .map(channel => this.stompClient.subscribe(channel, this.onReceiveMessage))
      }
    },
    unsubscribeMessage () {
      let handlers = this.subscribe.handlers
      if (handlers && handlers.length) {
        handlers.forEach(item => {
          item && item.unsubscribe()
        })
      }
      this.subscribe.handlers = []
    },
    loadUserMessage () {
      this.$ajax({
        url: '/support/message/biz/notification',
        method: 'post'
      }).then(response => {
        if (response.data) {
          this.updateMessageUnreadCount(response.data['unreadCount'])
        }
      })
      this.subscribeMessage()
    },
    onDeleteUserMessage (message) {
      if (!message.isRead) {
        this.decreaseMessageUnreadCount()
      }
    },
    bindMessageEvent () {
      this.$bus.$on(messageEvent.subscribe.NEW_MESSAGE, this.increaseMessageUnreadCount)
      this.$bus.$on(messageEvent.subscribe.READ_MESSAGE, this.decreaseMessageUnreadCount)
      this.$bus.$on(messageEvent.subscribe.DELETE_MESSAGE, this.onDeleteUserMessage)
      this.$bus.$on(messageEvent.subscribe.SET_ALL_MESSAGE_READ, this.cleanMessageUnreadCount)
    },
    unbindMessageEvent () {
      this.$bus.$off(messageEvent.subscribe.NEW_MESSAGE, this.increaseMessageUnreadCount)
      this.$bus.$off(messageEvent.subscribe.READ_MESSAGE, this.decreaseMessageUnreadCount)
      this.$bus.$off(messageEvent.subscribe.DELETE_MESSAGE, this.onDeleteUserMessage)
      this.$bus.$off(messageEvent.subscribe.SET_ALL_MESSAGE_READ, this.cleanMessageUnreadCount)
    }
  },
  created () {
    this.bindMessageEvent()
  },
  mounted () {
    this.loadUserMessage()
  },
  beforeDestroy () {
    this.unbindMessageEvent()
  },
  watch: {
    'visible': function (val) {
      if (val) {
        this.messageInit = true
      }
    },
    'messageType': function (newVal, oldVal) {
      if (newVal && oldVal) {
        let newIndex, oldIndex
        this.tab.options.forEach((option, index) => {
          if (option.type === newVal) {
            newIndex = index
          }
          if (option.type === oldVal) {
            oldIndex = index
          }
        })
        this.pullStyle = newIndex < oldIndex ? 'left' : 'right'
      }
    },
    'stompClient': function (val) {
      this.unsubscribeMessage()
      if (val) {
        this.subscribeMessage()
      }
    }
  }
}
</script>

<style lang="scss">
  .layout-message-center {
    height: 100%;
    background-color: #fff;
    & > .message-tabs-pane {
      .el-tabs {
        position: relative;
        & > .el-tabs__header {
          height: 38px;
          margin-bottom: 0;
          border-bottom: none;
          box-sizing: border-box;
          & > .el-tabs__nav-wrap {
            &.is-scrollable {
              padding: 0 27px;
              .el-tabs__nav-prev,
              .el-tabs__nav-next {
                width: 27px;
                height: 38px;
                line-height: 38px;
                text-align: center;
                font-size: 15px;
                box-sizing: border-box;
                i {
                  vertical-align: middle;
                }
              }
              .el-tabs__nav-prev {
                box-shadow: 1px 0 2px rgba(0,0,0,.05);
              }
              .el-tabs__nav-next {
                box-shadow: -1px 0 2px rgba(0,0,0,.05);
              }
            }
            &:after {
              height: 1px;
              background-color: rgba(0,21,41,.08);
            }
            .el-tabs__nav-scroll {
              .el-tabs__nav {
                border: none;
                border-radius: 0;
                .el-tabs__active-bar {
                  left: 15px;
                  height: 2px;
                }
                .el-tabs__item {
                  height: 38px;
                  line-height: 38px;
                  border: none;
                  &.is-top {
                    &:nth-child(2) {
                      margin-left: 15px;
                    }
                    &:last-child {
                      margin-right: 15px;
                    }
                  }
                  .el-badge {
                    display: block;
                    .el-badge__content {
                      border: none;
                      &.is-fixed {
                        top: 50%;
                        right: -15px;
                        z-index: 2;
                        transform: translateY(-100%) scale(.8);
                      }
                    }
                  }
                }
              }
            }
          }
        }
        & > .el-tabs__content {
          display: none;
          visibility: hidden;
        }
      }
    }
    & > .message-tabs-router {
      position: absolute;
      left: 0;
      top: 38px;
      right: 0;
      bottom: 0;
      overflow: hidden;
      i {
        font-size: 13px!important;
      }
    }
  }
</style>
